import React, { FC } from 'react'
import IconDots from './IconDots'
import { IconSVGProps } from '../IconSVG'

const IconDotsVertical: FC<IconSVGProps> = (props) => {
  return <IconDots transform="rotate(90deg) translate(1px, 0.5px)" {...props} />
}

export default IconDotsVertical
